import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { LeaderboardRow, ProfileResponse } from "../types/profile";

export const profileKeys = {
  me: ["profile"] as const,
  leaderboard: ["leaderboard"] as const,
};

export function useProfile(enabled: boolean) {
  return useQuery({
    queryKey: profileKeys.me,
    queryFn: async () => {
      const res = await api.get<ProfileResponse>("/profile");
      return res.data;
    },
    enabled,
    refetchInterval: 30_000,
  });
}

export function useLeaderboard(enabled: boolean) {
  return useQuery({
    queryKey: profileKeys.leaderboard,
    queryFn: async () => {
      const res = await api.get<LeaderboardRow[]>("/leaderboard");
      return res.data;
    },
    enabled,
    refetchInterval: 60_000,
    staleTime: 20_000,
  });
}
